// @flow
import React from 'react';

import { t } from 'Src/i18n';
import Image from 'Components/frameworks/image/Image';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { useTracking } from 'Tracking/tracking-api/useTracking';

type Props = {|
  onClose?: () => void,
  resort: $ReadOnly<{
    name: string,
    image?: string,
  }>,
|};

export const AlternativeDateSuggestionImmersive = (props: Props) => {
  const { onClose, resort } = props;

  const trackClick = useTracking({
    categoryGA: 'resort',
    actionGA: 'checkPricesKO',
  });

  return (
    <div className="AlternativeProposalsModal-image pb-6 w-full md:pt-8 md:pb-0 md:pr-6 md:rtl:pr-6 lg:pr-0 lg:rtl:pr-0 lg:mr-6 lg:rtl:mr-6 lg:rtl:ml-0">
      <Image
        imageUrl={resort.image}
        altMsg={resort.name}
        forceImage
        hasLazyLoading={false}
        mandatoryWidthAndHeight={{
          w: 734,
          h: 408,
        }}
      />
      {onClose ? (
        <div className="flex justify-end font-bold mt-4">
          <button
            type="button"
            className="AlternativeProposalsModal-doNotCheckPrice reset-button TextLink TextLink--default text-blue cursor flex items-center p-0 pr-2 rtl:pr-2 md:pr-0 md:rtl:pr-0"
            onClick={() => {
              onClose && onClose();
              trackClick({ labelGA: 'backResortPage' });
            }}
          >
            <span className="font-sans md:ml-1 md:rtl:ml-1">
              {t('booking.counterProposalPopIn.doNotCheckPriceLabel')}
            </span>
            <Icon name={ICONS.BOLDER_ARROW_FORTH} className="TextLink-iconRight" />
          </button>
        </div>
      ) : null}
    </div>
  );
};
